import { tv } from "tailwind-variants";

export const contentBlock = tv({
    base: [
        "tw:border tw:border-tertiary tw:rounded-xl tw:transition-colors tw:h-full tw:flex tw:flex-col tw:justify-start tw:overflow-hidden",
        "tw:hover:border-primary"
    ],
    variants: {
        expandImage: {
            true: "",
            false: "tw:p-4"
        }
    }
});
